var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-box",class:{
    'selection-box--active': _vm.active,
    'selection-box--disabled': _vm.disabled,
  }},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-6 col-lg-3 order-2 order-lg-1"},[_vm._t("left")],2),_c('div',{staticClass:"col-12 col-lg-5 order-1 order-lg-2"},[_vm._t("middle")],2),_c('div',{staticClass:"col-6 col-lg-4 order-1 order-lg-3"},[_vm._t("right")],2)]),_vm._t("bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }